import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import {
  commonProps,
  CommonProps,
  flexItemProps,
  FlexItemProps
} from '@bestyled/system'

export interface ContainerProps extends FlexItemProps, CommonProps {
  style?: any
}

/** The Container component is a generic container that has margin, padding, width, height and position */
export const Container = styled(ViewBase<ContainerProps>('Container'))`
  ${flexItemProps} ${commonProps}
` as React.FC<ContainerProps>
